module.exports = __webpack_public_path__ + "static/media/n00125.88cc1d65.jpg";